import { ChangeEvent, useContext, useEffect, useState } from 'react';
import { SearchField, UseGetCostCentersList } from '../../../../common';
import { AppContext } from '../../../../common/context/';
import { Modal } from '../BaseModal';
import { AssociateCostCenterProps } from './AssociateCostCenter.Props';

export const AssociateCostCenter = ({
    onClose,
    onSubmit,
    isOpen,
    employee,
    endDate,
    startDate,
    group,
}: AssociateCostCenterProps) => {
    const { langResources } = useContext(AppContext);
    const { costCenterList } = UseGetCostCentersList({ group, onClose });

    const [costCenterId, setCostCenterId] = useState<number>(-1);
    const [searchTerm, setSearchTerm] = useState('');
    const [costCenterCopy, setCostCenterCopy] = useState([...costCenterList]);

    const hanlderSubmit = () => {
        onSubmit(startDate, endDate, employee, costCenterId);
    };

    const handlerClose = () => {
        onClose(false);
    };

    const handlerChangeCostCenter = (costCenterId: number) => {
        setCostCenterId(costCenterId);
    };

    const handlerChangeTypeWorkshift = (e: ChangeEvent<HTMLInputElement>) => {
        let term = e.target.value;

        setSearchTerm(term);

        const filterList = costCenterList?.filter(
            (w) =>
                w.costCenter.name?.toLowerCase().includes(term.toLowerCase()) ||
                w.costCenter.observations?.toLowerCase().includes(term.toLowerCase())
        );

        setCostCenterCopy(filterList);
    };

    const handleResetSearchTerm = () => {
        setSearchTerm('');
        setCostCenterCopy(costCenterList);
    };

    useEffect(() => {
        setCostCenterCopy(costCenterList);
    }, [costCenterList]);

    return (
        <>
            {costCenterList.length > 0 && (
                <Modal
                    isOpen={isOpen}
                    modalTitle={langResources['assigned.cost.center.modal']['title']}
                    onClose={handlerClose}
                    onSubmit={hanlderSubmit}
                    disableSubmit={costCenterId === -1}
                    widthCustom='800px'
                >
                    <div className='modal-body text-black '>
                        <SearchField
                            selectItemId={handlerChangeTypeWorkshift}
                            inputPlaceholder={'Buscar'}
                            labelTitle={''}
                            searchTerm={searchTerm}
                            handleResetSearchTerm={handleResetSearchTerm}
                            dataListId=''
                        />
                        <div
                            className='row '
                            style={{ maxHeight: '50vh', overflowY: 'scroll' }}
                        >
                            <table className='table w-100 text-dark'>
                                <thead
                                    className=' text-black w-100 text-center position-sticky p-0 m-0'
                                    style={{ top: '0px', background: '#fff' }}
                                >
                                    <tr>
                                        <th className='fw-bold'>
                                            {
                                                langResources[
                                                    'assigned.business.units.modal'
                                                ]['id']
                                            }
                                        </th>
                                        <th className='fw-bold'>
                                            {
                                                langResources[
                                                    'assigned.cost.center.modal'
                                                ]['cost.center.name']
                                            }
                                        </th>
                                        <th className='fw-bold'>
                                            {
                                                langResources[
                                                    'assigned.cost.center.modal'
                                                ]['cost.center.observations']
                                            }
                                        </th>
                                    </tr>
                                </thead>

                                <tbody className='text-center'>
                                    {costCenterCopy.map((cc) => (
                                        <tr
                                            className={`text-selected ${
                                                costCenterId === cc.costCenter.id &&
                                                'text-selected--active'
                                            }`}
                                            key={cc.costCenter.id}
                                            onClick={(e) => {
                                                handlerChangeCostCenter(
                                                    cc.costCenter.id
                                                );
                                            }}
                                        >
                                            <th className='p-2'>
                                                {cc.costCenter.id}
                                            </th>
                                            <th className='p-2'>
                                                {cc.costCenter.name}
                                            </th>
                                            <th className='p-2'>
                                                {cc.costCenter.observations}
                                            </th>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Modal>
            )}
        </>
    );
};
